module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABAElEQVRYhe1Xyw7EIAgcNv3/X2YvNaHdqlUexixzqm0DMzIaABKJxNag1kdm1icgYmZu5hmMd1l/rAJ3kup3ooIQAWB2ExEjAHATcWgDDJE6RVieCbUAAMDIYTcWEWchCUM7rRFABKsK2FiIOlykxQzJAwYCemQuVjEmD0RayIE8ECXAiTwQJMCLPBAgwJM8sOoaNUQKWI0UsBrbC+hdcT8do/e12MLZllzyd3uhlYTfYHsLTXejssssVSrvmJnk1NV6bsW4/zMloJZEWkuuRyzXi/GUZ1iA9gwUEk9zsMVYaTORTeDN7r6B2yG+73qtClpMVaCQkWttjNl/Eol/xxfcJqw/9KgVswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEFWD_A.png
// module id = 69
// module chunks = 0